import timer from "../../checkout/countdown-timer";
import calcWorth from "./calc-worth";

export default {
  loader: $(".js-tour-loader"),
  availabilityResponse: {},
  showLoader() {
    return this.loader.show();
  },

  hideLoader() {
    return this.loader.hide();
  },

  errorHandler(req, text, error, form) {
    var errors = [];
    var response = {};
    this.hideLoader();
    $(".js-travellers-form").fadeIn();
    if (!form || form.length === 0) {
      return;
    }
    try {
      response = req.responseJSON;
      for (var prop in response.errors) {
        errors.push(response.errors[prop]);
      }

      $(form)
        .find(".js-information__error-box")
        .text(errors.join("\n"));
      $(form)
        .find(".js-information__error-box")
        .removeClass("hidden");
      $(form)
        .find(".js-information__error-box")
        .closest(".js-field-dropdown__label")
        .addClass("has-error");

      $(".js-book-now").attr("disabled", true);
    } catch (e) {}
  },
  updateQuote(resolve, reject) {
    const parent = $(".js-field-dropdown__label-for-availability"),
      productId = $(parent)
        .find('input[name="product_id"]')
        .val(),
      age_bands = JSON.parse(
        $(parent)
          .find('input[name="age_bands"]')
          .val()
      ),
      variationId = $(parent)
        .find('.js-product-field[name="tour"]')
        .data("value");
    let quoteItem = this.availabilityResponse;
    quoteItem.ageBandPrices = age_bands;
    this.showLoader();
    $.ajax({
      method: "post",
      url: "/quote/storeItem/" + productId + "/" + variationId,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(quoteItem)
    })
      .done(response => {
        $.ajax({
          method: "get",
          url: "/checkout/travellers-form"
        }).done(response => {
          this.updateAndShowTravellersForm(response);

          const firstName = $(".js-firstname-validate");
          const lastName = $(".js-lastname-validate");

          for (let i = 0; i < firstName.length; i++) {
            $(firstName[i]).rules("add", {
              minlength: 2
            });

            $(lastName[i]).rules("add", {
              minlength: 2
            });
          }

          this.hideLoader();
        });
        resolve(response);
      })
      .fail((e, rr, ors) => {
        this.errorHandler(e, rr, ors, "");
        reject(e);
      });
  },
  updateAndShowTravellersForm(form) {
    let cachedValues = {};
    let firstNameInput = $(".js-travellers-form").find(
        'input[name^="first_name"]'
      ),
      lastNameInput = $(".js-travellers-form").find('input[name^="last_name"]');
    firstNameInput.each(function() {
      let id = $(this).data("band-id"),
        val = $(this).val();
      cachedValues.id = val;
    });
    lastNameInput.each(function() {
      let id = $(this).data("band-id"),
        val = $(this).val();
      cachedValues.id = val;
    });

    let travellersForm = $(".js-travellers-form").html(form);

    let sortedForm = travellersForm
      .find(".js-travellers-variation")
      .sort(function(a, b) {
        let left = $(a).data("item-id");
        let right = $(b).data("item-id");

        left = $('.js-product-order[data-item-id="' + left + '"]').data("sort");
        right = $('.js-product-order[data-item-id="' + right + '"]').data(
          "sort"
        );

        return left < right ? -1 : left > right ? 1 : 0;
      });

    travellersForm.find(".js-optional-travellers-form").html(sortedForm);

    for (var prop in cachedValues) {
      let input = travellersForm
        .find('input[data-band-id="' + prop + '"]')
        .val(cachedValues[prop]);
      input.parent().addClass("has-value");
    }
    $(".js-travellers-form").fadeIn();
  },
  checkAvailability(form) {
    if (form instanceof $ === false) {
      form = $(form);
    }
    const ageBands = form.find(".js-field-dropdown-tickets__category"),
      productId = form.find('input[name="product_id"]').val(),
      variationId =
        form.find('.js-product-field[name="tour"]').data("value") ||
        form.find(".js-tourgrade").data("value"),
      ticketsField = form.find(".js-field-dropdown__tickets"),
      isCheckout = form.find(".js-is-checkout") ? true : false,
      orderItem = form.find(".js-product-order");
    let ageBandsOptions = [];

    ageBands.each(function(index, el) {
      let ageBandId = $(this).data("id"),
        count = $(this)
          .find('input[type="number"]')
          .val(),
        option = {
          bandId: ageBandId,
          count: count
        };

      if ($(this).data("time")) {
        option.time = $(this).data("time");
      }

      if ($(this).data("time-pk")) {
        option.timePk = $(this).data("time-pk");
      }

      if (form.find('.js-product-field[name="tour"]').data("pk")) {
        option.timePk = form.find('.js-product-field[name="tour"]').data("pk");
      }

      if ($(this).data("pk")) {
        option.pk = $(this).data("pk");
      }

      if (count > 0) ageBandsOptions.push(option);
    });

    if (!productId || !variationId || ageBandsOptions.length == 0) return;
    let date = form.find(".js-field-dropdown__calendar").length
      ? form.find(".js-field-dropdown__calendar").val()
      : $(".js-field-dropdown__calendar").val();

    let data = {
      date: date,
      ageBands: ageBandsOptions,
      orderItem: orderItem.data("item-id")
    };

    let promise = new Promise((resolve, reject) => {
      $.ajax({
        method: "post",
        url: "/products/" + productId + "/variations/" + variationId,
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(data),
        beforeSend: () => {
          this.showLoader();
          $(form)
            .find(".js-information__error-box")
            .addClass("hidden");
          $(form)
            .find(".js-field-dropdown__label.has-error")
            .removeClass("has-error");
          $(".js-travellers-form").fadeOut(600);
          $(".js-checkout-all-products").addClass("disabled");
          $(".js-checkout-all-products").attr("disabled", true);
        }
      })
        .done(response => {
          this.hideLoader();
          if (
            response.status == true &&
            !$(ticketsField).hasClass("is-disabled")
          ) {
            form.find(".js-book-now").removeAttr("disabled");
          }
          this.availabilityResponse = response.data;
          if (this.availabilityResponse.hasOwnProperty("ageBands") == false) {
            this.availabilityResponse.ageBands = data.ageBands;
          }
          this.availabilityResponse.productId = productId;
          this.availabilityResponse.variationId = variationId;

          $(".js-checkout-all-products").removeClass("disabled");
          $(".js-checkout-all-products").removeAttr("disabled");

          if ($("label").is(".js-field-dropdown__label-for-availability")) {
            let updater = new Promise((res, rej) => {
              this.updateQuote(res, rej);
            }).then(() => {
              resolve(response);
            });
          }
        })
        .fail((e, rr, ors) => {
          this.availabilityResponse = {};
          this.errorHandler(e, rr, ors, form);
          reject(e);
        })
        .always(function() {
          if ($("label").is(".js-field-dropdown__label-for-availability")) {
            $(".js-field-dropdown__label-for-availability").removeClass(
              "js-field-dropdown__label-for-availability"
            );
          }
        });
    }).then(async response => {
      if (isCheckout && response.status == true && response.data.isBroadway) {
        try {
          const res = await $.ajax({
            method: "post",
            url:
              "/products/" +
              productId +
              "/variations/" +
              variationId +
              "/selectSeats",
            beforeSend: () => {
              this.showLoader();
              $(form)
                .find(".js-information__error-box")
                .addClass("hidden");
              $(form)
                .find(".js-field-dropdown__label.has-error")
                .removeClass("has-error");
              $(".js-travellers-form").fadeOut(600);
              $(".js-checkout-all-products").addClass("disabled");
              $(".js-checkout-all-products").attr("disabled", true);
            },
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify(data)
          }).done(response => {
            this.hideLoader();
            if (
              response.status == true &&
              !$(ticketsField).hasClass("is-disabled")
            ) {
              form.find(".js-book-now").removeAttr("disabled");
            }

            if (response.expiration) {
              $(".js-expiration-datetime").val(response.expiration);
              $(".js-expiration-datetime-container").removeClass("hidden");
              timer.timer();
            }

            let seatsHtml = "";
            for (let ageBand in response.data) {
              for (let i = 0; i < response.data[ageBand].confirmationSeats.length; i++) {
                seatsHtml += `${response.data[ageBand].confirmationSeats[i].area}
                      ${response.data[ageBand].confirmationSeats[i].row}
                      ${formatBroadwaySeats(
                        response.data[ageBand].confirmationSeats[i]
                      )}`;
                
                if (i + 1 < response.data[ageBand].confirmationSeats.length) {
                  seatsHtml += ', ';
                }
              }
              
            }

            let updateTarget = orderItem.find(".js-broadway-seats");
            if ($("a.view-seatmap-button").length > 0) {
              updateTarget = orderItem.find("a.view-seatmap-button");
            }
            updateTarget.html(seatsHtml);

            let modalHtml = '<span>Seat Locations:</span> ' + seatsHtml;
            $('div.seatmap-modal-content__seat-locations').html(modalHtml);

            if (response.recommendedSeatsPrice) {
              orderItem
                .find(".js-is-recommended")
                .data("cost", response.recommendedSeatsPrice);
              orderItem.find(".js-is-recommended").trigger("change");
            }

            $(".js-checkout-all-products").removeClass("disabled");
            $(".js-checkout-all-products").removeAttr("disabled");
          });
        } catch (error) {
          if (error.responseJSON.expiration) {
            $(".js-expiration-datetime").val(error.responseJSON.expiration);
            $(".js-expiration-datetime-container").removeClass("hidden");
            timer.timer();
          }
          this.errorHandler(error, "", "", form);
        }
      }

      return response;
    });
  }
};

const formatBroadwaySeats = confirmationSeats => {
  return confirmationSeats.highSeatNumber == confirmationSeats.lowSeatNumber
    ? confirmationSeats.highSeatNumber == 0
      ? ""
      : confirmationSeats.highSeatNumber
    : `${confirmationSeats.lowSeatNumber} - ${confirmationSeats.highSeatNumber}`;
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/tickets-form/availability.js